import logo from '../images/logo.png';
import lince from '../images/lince.png';
import './landing.css';
import { useState, useEffect } from 'react';
import { get } from './utils/utils';

function Landing() {

  const [message, setMessage] = useState('');

  useEffect(() => {
    get({
      url: 'message.php',
    })
      .then((response) => response.data)
      .then((data) => {
        console.log(data);
        setMessage(data[0].message ?? '');
      });
  }, []);

  return (
    <div className='bufete-landing'>
      <img src={logo} className='bufete-logo' />
      
      <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Lince Legal</p>
      <div style={{backgroundColor: 'white'}} className="proceedings-section-line"></div>
      <p><b>MISIÓN:</b><br />Establecer como eje rector en la formación humanista de los estudiantes, el fomento de la empatía y sensibilidad hacia la problemática social y jurídica de las personas y la responsabilidad universitaria de la aplicación de la doctrina, la legislación y los medios alternos de solución de controversias que le permitan a los grupos vulnerables tener acceso a la impartición de justicia a través de la asesoría legal de forma gratuita, crear en el estudiante conciencia crítica de acuerdo a las necesidades fundamentales de la sociedad.</p>
      <p><b>VISIÓN:</b><br />Construcción permanente de la conciencia social, a partir del compromiso establecido por la Universidad Autónoma de Occidente hacia la comunidad estudiantil, para la proyección vanguardista dirigida a una sociedad en transformación constante.</p>
      <div style={{backgroundColor: 'white'}} className="proceedings-section-line"></div>
      <p>Av. del Mar 1200, Fraccionamiento Tellerías <br /> C.P. 82100, Mazatlán, Sinaloa.</p>
      <p></p>
      <img src={lince} className='bufete-lince' />
      <div className='bufete-mensaje' style={{color: '#852244'}} dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );



}

export default Landing;
